export default [
    {
        value: "Caucasian",
        label: "Caucasian",
    },
    {
        value: "Hispanic",
        label: "Hispanic",
    },
    {
        value: "African American",
        label: "African American",
    },
    {
        value: "Asian",
        label: "Asian",
    },
    {
        value: "Middle Eastern",
        label: "Middle Eastern",
    },

]